// src/context/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';

// Create an Authentication Context
const AuthContext = createContext();

// Custom hook to use the auth context
export const useAuth = () => useContext(AuthContext);

// Provider component
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check for existing user session on initial load
  useEffect(() => {
    const checkLoggedIn = () => {
      const userData = localStorage.getItem('userData');
      
      if (userData) {
        // If we have user data in localStorage, parse and use it
        try {
          const parsedUser = JSON.parse(userData);
          setUser(parsedUser);
        } catch (error) {
          // If there's an error parsing the JSON, clear localStorage
          console.error('Error parsing user data:', error);
          localStorage.removeItem('userData');
          setUser(null);
        }
      }
      
      setLoading(false);
    };
    
    checkLoggedIn();
  }, []);

  // Login function
  const login = (userData) => {
    setUser(userData);
  };

  // Logout function
  const logout = () => {
    localStorage.removeItem('userData');
    setUser(null);
  };

  // Authentication check
  const isAuthenticated = !!user?.isAuthenticated;

  // Provide auth context values to children components
  return (
    <AuthContext.Provider 
      value={{ 
        user, 
        loading, 
        isAuthenticated,
        login, 
        logout 
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;